import React from "react";
const REACT_APP_PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;

function NewClients({ chart_data }) {
  const data = Array.isArray(chart_data) ? chart_data : [];
  if (!data.length) {
    return <div className="text-muted">No Data Available</div>;
  }

  return (
    <>
      {data.map((emp) => (
        <div key={emp.id} className="card shadow-none mb-2">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
              <div className="d-flex align-items-start">
                <img
                  src={
                    emp.logo
                      ? `${REACT_APP_PINE_BASE_URL}/files/companyLogo/${emp.logo}`
                      : "assets/img/users/default.jpg"
                  }
                  className="avatar avatar-lg img-fluid me-3" alt={emp.company}
                  style={{ width: "83px", height: "30px" }}
                />

                <div>
                  <div className="d-flex align-items-center flex-wrap mb-1">
                    <h6 className="fs-16 fw-semibold mb-0 me-2">
                      {emp.company}
                    </h6>
                  </div>
                  <p className="text-muted fs-13 mb-1">
                     Business Developed by {emp.bd_by}
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-center">
                <span className="fs-13 text-muted">
                  {emp.influenced?.trim() && (
                    <span>Influenced by: {emp.influenced}</span>
                  )}
                </span>
              </div>
            </div>     
          </div>
        </div>
            ))}
    </>
  );
}

export default NewClients;